import { render, staticRenderFns } from "./StudentsCompanyInteraction.vue?vue&type=template&id=f1f1f5cc&scoped=true"
import script from "./StudentsCompanyInteraction.vue?vue&type=script&lang=js"
export * from "./StudentsCompanyInteraction.vue?vue&type=script&lang=js"
import style0 from "./StudentsCompanyInteraction.vue?vue&type=style&index=0&id=f1f1f5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f1f5cc",
  null
  
)

export default component.exports